import React from 'react';
import RackCard from '../components/RackCard';

const FavoritesScreen = ({
  darkMode,
  favorites = [], // Provide default empty array
  currentSlide = {}, // Provide default empty object
  handleNextSlide = () => { }, // Provide default empty function
  handlePrevSlide = () => { }, // Provide default empty function
  addToCart = () => { }, // Provide default empty function
  isInCart = () => false, // Provide default function returning false
  toggleFavorite = () => { }, // Provide default empty function
  isFavorite = () => false // Provide default function returning false
}) => {
  // Ensure favorites is an array
  const favoritesArray = Array.isArray(favorites) ? favorites : [];

  return (
    <>
      <h2 className={`text-xl font-bold mb-4 ${darkMode ? 'text-white' : ''}`}>Избранное</h2>
      {favoritesArray.length > 0 ? (
        favoritesArray.map(rack => (
          <RackCard
            key={rack.id}
            rack={rack}
            showFavoriteButton={true}
            darkMode={darkMode}
            currentSlide={currentSlide}
            handleNextSlide={handleNextSlide}
            handlePrevSlide={handlePrevSlide}
            addToCart={addToCart}
            isInCart={isInCart}
            toggleFavorite={toggleFavorite}
            isFavorite={isFavorite}
          />
        ))
      ) : (
        <div className={`text-center py-8 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
          <i className="fas fa-heart text-4xl mb-3"></i>
          <p>У вас пока нет избранных багажников</p>
        </div>
      )}
    </>
  );
};

export default FavoritesScreen;